// node_modules/ftdomdelegate/main.js
function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
        this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
}
Delegate.prototype.root = function(root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
        for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, true);
            }
        }
        for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, false);
            }
        }
    }
    if (!root || !root.addEventListener) {
        if (this.rootElement) {
            delete this.rootElement;
        }
        return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, true);
        }
    }
    for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, false);
        }
    }
    return this;
};
Delegate.prototype.captureForType = function(eventType) {
    return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
};
Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
        throw new TypeError("Invalid event type: " + eventType);
    }
    if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
    }
    if (useCapture === void 0) {
        useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== "function") {
        throw new TypeError("Handler must be a type of Function");
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
        if (root) {
            root.addEventListener(eventType, this.handle, useCapture);
        }
        listenerMap[eventType] = [];
    }
    if (!selector) {
        matcherParam = null;
        matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
        matcherParam = selector;
        matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
        matcherParam = selector.slice(1);
        matcher = matchesId;
    } else {
        matcherParam = selector;
        matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
        selector,
        handler,
        matcher,
        matcherParam
    });
    return this;
};
Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
    }
    if (useCapture === void 0) {
        this.off(eventType, selector, handler, true);
        this.off(eventType, selector, handler, false);
        return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
        for (singleEventType in listenerMap) {
            if (listenerMap.hasOwnProperty(singleEventType)) {
                this.off(singleEventType, selector, handler);
            }
        }
        return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
        return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
        listener = listenerList[i];
        if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
            this._removedListeners.push(listener);
            listenerList.splice(i, 1);
        }
    }
    if (!listenerList.length) {
        delete listenerMap[eventType];
        if (this.rootElement) {
            this.rootElement.removeEventListener(eventType, this.handle, useCapture);
        }
    }
    return this;
};
Delegate.prototype.handle = function(event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";
    if (event[eventIgnore] === true) {
        return;
    }
    target = event.target;
    if (target.nodeType === 3) {
        target = target.parentNode;
    }
    if (target.correspondingUseElement) {
        target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
        case 1:
            listenerList = this.listenerMap[1][type];
            break;
        case 2:
            if (this.listenerMap[0] && this.listenerMap[0][type]) {
                listenerList = listenerList.concat(this.listenerMap[0][type]);
            }
            if (this.listenerMap[1] && this.listenerMap[1][type]) {
                listenerList = listenerList.concat(this.listenerMap[1][type]);
            }
            break;
        case 3:
            listenerList = this.listenerMap[0][type];
            break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
        for (i = 0; i < l; i++) {
            listener = listenerList[i];
            if (!listener) {
                break;
            }
            if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
                toFire = [];
            } else if (listener.matcher.call(target, listener.matcherParam, target)) {
                toFire.push([event, target, listener]);
            }
        }
        if (target === root) {
            break;
        }
        l = listenerList.length;
        target = target.parentElement || target.parentNode;
        if (target instanceof HTMLDocument) {
            break;
        }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
        if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
            continue;
        }
        returned = this.fire.apply(this, toFire[i]);
        if (returned === false) {
            toFire[i][0][eventIgnore] = true;
            toFire[i][0].preventDefault();
            ret = false;
            break;
        }
    }
    return ret;
};
Delegate.prototype.fire = function(event, target, listener) {
    return listener.handler.call(target, event, target);
};
function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
}
function matchesRoot(selector, element) {
    if (this.rootElement === window) {
        return element === document || element === document.documentElement || element === window;
    }
    return this.rootElement === element;
}
function matchesId(id, element) {
    return id === element.id;
}
Delegate.prototype.destroy = function() {
    this.off();
    this.root();
};
var main_default = Delegate;

// Helper Functions
function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        detail: data
    }));
}

var CustomHTMLElement = class extends HTMLElement {
    constructor() {
        super();
        this._hasSectionReloaded = false;
        if (Shopify.designMode) {
            this.rootDelegate.on("shopify:section:select", (event) => {
                const parentSection = this.closest(".shopify-section");
                if (event.target === parentSection && event.detail.load) {
                    this._hasSectionReloaded = true;
                }
            });
        }
    }
    get rootDelegate() {
        return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
        return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
        triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
        triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
        const onBecameVisible = () => {
            this.classList.add("became-visible");
            this.style.opacity = "1";
        };
        return new Promise((resolve) => {
            if (window.IntersectionObserver) {
                this.intersectionObserver = new IntersectionObserver((event) => {
                    if (event[0].isIntersecting) {
                        this.intersectionObserver.disconnect();
                        requestAnimationFrame(() => {
                            resolve();
                            onBecameVisible();
                        });
                    }
                }, intersectionObserverOptions);
                this.intersectionObserver.observe(this);
            } else {
                resolve();
                onBecameVisible();
            }
        });
    }
    disconnectedCallback() {
        var _a;
        this.delegate.destroy();
        this.rootDelegate.destroy();
        (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
        delete this._delegate;
        delete this._rootDelegate;
    }
};

// js/common/product/product-form.js
const ProductForm = class extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector("form");
        if (this.form != undefined) {
            this.form.addEventListener("submit", this._onSubmit);
        }
        this.quickATC = this.querySelector(".ProductItem__ATCButton.ProductItem__ATCButton--quickAdd");
        if (this.quickATC != null) {
            this.quickATC.addEventListener("click", this._onSubmit);
        }
    }
    connectedCallback() {
        if (this.form != undefined) {
            this.form.id.disabled = false;
        }
    }
    async _onSubmit(event) {
        event.preventDefault();

        if (!this.checkValidity()) {
            this.reportValidity();
            return;
        }
        let formData;
        let submitButtons;
        let variantId;
        if (this.dataset.withoutForm == "true") {
            const productData = JSON.parse(this.dataset.productData);
            variantId = productData.variants[0].id;
            formData = new FormData();
            formData.set("id", variantId);
            formData.set("quantity", 1);
            formData.set("form_type", "product");
            formData.set("sections", "cart-drawer,variant-added");
            formData.set("sections_url", `${Shopify.routes.root}variants/${variantId}`);

            if (this.dataset.lineItemProperties != undefined) {
                for (const [key, value] of Object.entries(JSON.parse(this.dataset.lineItemProperties))) {
                    formData.set(`properties[${key}]`, value);
                }
            }

            submitButtons = [this];
        } else {
            let form = this;
            if (this.form != undefined) {
                form = this.form;
            }
            submitButtons = Array.from(form.elements).filter((button) => button.type === "submit");
            variantId = form.id.value

            formData = new FormData(form);
            formData.set("sections", "cart-drawer,variant-added");
            formData.set("sections_url", `${Shopify.routes.root}variants/${variantId}`);
        }
        submitButtons.forEach((submitButton) => {
            submitButton.setAttribute("disabled", "disabled");
            submitButton.setAttribute("aria-busy", "true");
        });
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            body: formData,
            method: "POST",
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        });
        const responseJson = await response.json();

        submitButtons.forEach((submitButton) => {
            submitButton.removeAttribute("disabled");
            submitButton.removeAttribute("aria-busy");
        });
        if (response.ok) {
            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent["sections"] = responseJson["sections"];
            this.dispatchEvent(new CustomEvent("variant:add", {
                bubbles: true,
                detail: {
                    items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                    cart: cartContent
                }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    baseEvent: "variant:add",
                    newItem: {
                        product_id: responseJson["product_id"],
                    },
                    cart: cartContent
                }
            }));
        } else {
            this.dispatchEvent(new CustomEvent("cart:error", {
                bubbles: true,
                detail: {
                    error: responseJson["description"]
                }
            }));
        }
    }
};
if (!window.customElements.get("product-form")) {
    window.customElements.define("product-form", ProductForm);
}

// js/common/cart/cart-info-overlay.js
const CartInfoOverlay = class extends CustomHTMLElement {
    constructor() {
        super();
        this._onCartChangedListener = this._onCartChanged.bind(this);
    }
    connectedCallback() {
        document.addEventListener("variant:add", this._onCartChangedListener);
    }
    disconnectedCallback() {
        document.removeEventListener("variant:add", this._onCartChangedListener);
    }
    _onCartChanged(event) {
        this.hidden = false;
        this.classList.add("show");
        const cart = event.detail.cart;

        setTimeout(() => {
            this.classList.remove("show");
        }, 2000);

        setTimeout(() => {
            this.hidden = true;
        }, 2600);
    }
}
if (!window.customElements.get("cart-info-overlay")) {
    window.customElements.define("cart-info-overlay", CartInfoOverlay);
}

const CartTemplate = class extends CustomHTMLElement {
    constructor() {
        super();
        this._onCartChangedListener = this._onCartChanged.bind(this);
        this._onCartRefreshListener = this._onCartChanged.bind(this);
    }
    connectedCallback() {
        document.addEventListener("cart:change", this._onCartChangedListener);
        document.addEventListener("cart:refresh", this._onCartRefreshListener);
    }
    disconnectedCallback() {
        document.removeEventListener("cart:change", this._onCartChangedListener);
        document.removeEventListener("cart:refresh", this._onCartRefreshListener);
    }
    _onCartChanged(event) {
        let updatedCartContent = new DOMParser().parseFromString(event.detail.cart["sections"]["cart-template"], "text/html");

        if (updatedCartContent.querySelectorAll("line-item").length > 0) {
            const currentLineItemsElement = this.querySelector(".Cart__ItemList");
            const updatedLineItemsElement = updatedCartContent.querySelector(".Cart__ItemList");
            if (!currentLineItemsElement) {
                this.replaceChildren(document.createRange().createContextualFragment(updatedCartContent.querySelector(".cart-template").innerHTML));
                this.reconnectedCallback();
            } else {
                currentLineItemsElement.innerHTML = updatedLineItemsElement.innerHTML;
                this.querySelector('.Cart__Footer').replaceChildren(...updatedCartContent.querySelector('.Cart__Footer').childNodes);
            }
        } else {
            this.replaceChildren(...updatedCartContent.querySelector(".cart-template").childNodes);
            this.reconnectedCallback();
        }
    }
}
if (!window.customElements.get("cart-template")) {
    window.customElements.define("cart-template", CartTemplate);
}

// js/common/cart/cart-drawer.js
const CartDrawer = class extends HTMLElement {
    constructor() {
        super();
        this._onCartChangedListener = this._onCartChanged.bind(this);
        this._onCartRefreshListener = this._onCartRefresh.bind(this);
        this._onVariantAddedListener = this._onVariantAdded.bind(this);
        this._onCloseButtonClicked = this.hide.bind(this);
        this._onCartIconClicked = this.show.bind(this);
        this._onShippingSelectionChanged = this.setShippingCosts.bind(this);
        this._onCheckoutButtonClickedListener = this._onCheckoutButtonClicked.bind(this);
        this.initGWPFunctionality();
    }
    connectedCallback() {
        document.addEventListener("cart:change", this._onCartChangedListener);
        document.addEventListener("cart:refresh", this._onCartRefreshListener);
        document.addEventListener("cart:show", this._onCartIconClicked);
        document.addEventListener("variant:add", this._onVariantAddedListener);
        document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]').addEventListener("click", this._onCartIconClicked);
        this.querySelector('button[data-action="close-drawer"]').addEventListener("click", this._onCloseButtonClicked);
        if (this.querySelector('select#cartShippingSelection')) {
            this.querySelector('select#cartShippingSelection').addEventListener("change", this._onShippingSelectionChanged);
        }
        if (this.querySelector('.Cart__Checkout')) {
            this.querySelector('.Cart__Checkout').addEventListener("click", this._onCheckoutButtonClickedListener);
        }
    }
    disconnectedCallback() {
        document.removeEventListener("cart:change", this._onCartChangedListener);
        document.removeEventListener("cart:refresh", this._onCartRefreshListener);
        document.removeEventListener("cart:show", this._onCartIconClicked);
        document.removeEventListener("variant:add", this._onVariantAddedListener);
        document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]').removeEventListener("click", this._onCartIconClicked);
        this.querySelector('button[data-action="close-drawer"]').removeEventListener("click", this._onCloseButtonClicked);
        if (this.querySelector('select#cartShippingSelection')) {
            this.querySelector('select#cartShippingSelection').removeEventListener("change", this._onShippingSelectionChanged);
        }
    }
    reconnectedCallback() {
        this.querySelector('button[data-action="close-drawer"]').removeEventListener("click", this._onCloseButtonClicked);
        if (this.querySelector('select#cartShippingSelection')) {
            this.querySelector('select#cartShippingSelection').removeEventListener("change", this._onShippingSelectionChanged);
        }
        this.querySelector('button[data-action="close-drawer"]').addEventListener("click", this._onCloseButtonClicked);
        if (this.querySelector('select#cartShippingSelection')) {
            this.querySelector('select#cartShippingSelection').addEventListener("change", this._onShippingSelectionChanged);
        }
    }
    get open() {
        return this.getAttribute("aria-hidden") == "false" ? true : false;
    }
    initGWPFunctionality() {
        this.cartTotal = this.dataset.totalAmount;
        // Array with info about cart items
        this.cartItems = [];
        this.cartTotal_withoutGift = 0;

        this.querySelectorAll(".CartItem").forEach(item => {
            let ignoreProduct = false;

            if (item.dataset.productTags.includes(gwpExclutionTag)) {
                ignoreProduct = true;
            }
            if (item.dataset.properties.includes("GWP")) {
                ignoreProduct = true;
            }
            if (!ignoreProduct) {
                this.cartTotal_withoutGift += parseFloat(item.dataset.linePrice);
            }

            this.cartItems.push({
                "variantID": item.dataset.variantId,
                "productID": item.dataset.productId,
                "properties": item.dataset.properties,
                "quantity": parseInt(item.dataset.quantity),
                "id": item.dataset.lineId,
                "price": parseInt(item.dataset.variantPrice)
            });

            // this._initFreeGWPGifts();
        });
    }
    // This Function is not fully tested and is part of the logic for free gifts in cart with ATC-Button
    initFreeGWPGifts(_tempElement = null) {
        if (document.querySelector(".gwpFreeGiftSelection--wrapper") != null) {
            let _productsInCart = {};
            let _suggestGiftProducts = {};
            gwpProducts.forEach(product => {
                _productsInCart[product["cat"]] = {"init": 0, "avail": 0};

                _suggestGiftProducts[product["cat"]] = {"varID": product["varID"], "suggest": false}
            })

            let itemWrapper = document.querySelector(".Cart__ItemList");
            if (_tempElement != null) {
                itemWrapper = _tempElement.querySelector(".Cart__ItemList");
            }
            let cartItems = itemWrapper.querySelectorAll(".CartItem");

            cartItems.forEach(item => {
                gwpProducts.forEach(product => {
                    if (product["varID"] == parseInt(item.dataset.variantId)) {
                        _productsInCart[product["cat"]]["avail"] += parseInt(item.dataset.quantity);
                        _productsInCart[product["cat"]]["init"] += parseInt(item.dataset.quantity);
                    }
                });
            });

            let _availProducts = [];

            gwpBundles.forEach(bundle => {
                let bundleActive = true;
                while(bundleActive) {
                    _availProducts = [];
                    bundle["config"].forEach(product => {
                        let available = 0;
                        if (_productsInCart[product["cat"]]["avail"] < product["amount"]) {
                            bundleActive = false;
                            available = _productsInCart[product["cat"]]["avail"];
                        } else {
                            available = product["amount"];
                        }
                        _availProducts.push({"cat": product["cat"], "amountAvail": available, "amountNeeded": product["amount"]});
                    });
                    if (bundleActive) {
                        bundle["config"].forEach(product => {
                            _productsInCart[product["cat"]]["avail"] -= product["amount"];
                        });
                    }
                }
            });

            gwpBundles.forEach(bundle => {
                let bundleActive = true;
                while(bundleActive) {
                    _availProducts = [];
                    bundle["config"].forEach(product => {
                        let available = 0;
                        if (_productsInCart[product["cat"]]["avail"] < product["amount"]) {
                            bundleActive = false;
                            available = _productsInCart[product["cat"]]["avail"];
                        } else {
                            available = product["amount"];
                        }
                        _availProducts.push({"cat": product["cat"], "amountAvail": available, "amountNeeded": product["amount"]});
                    });
                    if (bundleActive) {
                        bundle["config"].forEach(product => {
                            _productsInCart[product["cat"]]["avail"] -= product["amount"];
                        });
                    } else {
                        let suggestGift = true;
                        _availProducts.forEach(product => {
                            if (product["cat"] == bundle["free"]) {
                                if (product["amountAvail"] + 1 != product["amountNeeded"]) {
                                    suggestGift = false;
                                }
                            } else {
                                if (product["amountAvail"] != product["amountNeeded"]) {
                                    suggestGift = false;
                                }
                            }
                        });
                        if (suggestGift) {
                            _suggestGiftProducts[bundle["free"]]["suggest"] = true;
                        }
                    }
                }
            });

            let min1ProductSuggested = false;

            gwpProducts.forEach(product => {
                if (_suggestGiftProducts[product["cat"]]["suggest"]) {
                    min1ProductSuggested = true;
                    if (_tempElement != null) {
                        let wrapper = _tempElement.querySelector(`.gwpFreeGiftSelection--wrapper`);
                        let item = _tempElement.querySelector(`.gwpFreeGiftSelection__item--${product["varID"]}`);
                        wrapper.hidden = false;
                        item.hidden = false;
                    } else {
                        let wrapper = document.querySelector(`.gwpFreeGiftSelection--wrapper`);
                        let item = document.querySelector(`.gwpFreeGiftSelection__item--${product["varID"]}`);
                        wrapper.hidden = false;
                        item.hidden = false;
                    }
                }
                this.element.hidden = false;
            });

            // This functionality is hiding the progress-bar if a free gift is suggested

            // if (min1ProductSuggested) {
            //   if (_tempElement != null) {
            //     let progressBarWrapper = _tempElement.querySelector(`.gwpProgressBar--wrapper`);
            //     let gwpMessageWrappers = _tempElement.querySelectorAll(`.gwpMessage--wrapper`);
            //     progressBarWrapper.hidden = true;
            //     gwpMessageWrappers.forEach(wrapper => {
            //       wrapper.hidden = true;
            //     });
            //   } else {
            //     let progressBarWrapper = document.querySelector(`.gwpProgressBar--wrapper`);
            //     let gwpMessageWrappers = document.querySelectorAll(`.gwpMessage--wrapper`);
            //     progressBarWrapper.hidden = true;
            //     gwpMessageWrappers.forEach(wrapper => {
            //       wrapper.hidden = true;
            //     });
            //   }
            // }
        }
    }
    // This Function is not fully tested and is part of the logic for free gifts in cart with ATC-Button
    addFreeGiftToCart(event, target) {
        event.preventDefault(); // Prevent form to be submitted

        // var addToCartButton = this.element.querySelector('.gwpFreeGiftSelection__AddToCart');
        let varID = target.dataset.varId;
        let varPrice = target.dataset.varPrice;

        // First, we switch the status of the button
        target.setAttribute('disabled', 'disabled');

        // Then we add the product in Ajax
        // var formElement = this.element.querySelector(`.gwpFreeGiftSelection__item--${varID}`);

        var serializedFormData = `{"form_type": "product", "utf8": "✓", "id": "${varID}", "quantity": "1"}`;

        fetch(window.theme.localeRootUrl + '/cart/add.js', {
            body: serializedFormData,
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
            }
        }).then(function (response) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            if (response.ok) {
                target.removeAttribute('disabled');
                // We simply trigger an event so the mini-cart can re-render
                _this8.element.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                        variant: {
                            "id": varID,
                            "price": varPrice
                        },
                        quantity: 1,
                        productData: _this8.productData
                    }
                }));
            } else {
                response.json().then(function (content) {
                    var errorMessageElement = document.createElement('span');
                    errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                    errorMessageElement.innerHTML = content['description'];
                    target.removeAttribute('disabled');
                    target.insertAdjacentElement('afterend', errorMessageElement);
                    setTimeout(function () {
                        errorMessageElement.remove();
                    }, 2500);
                });
            }
        });

        event.preventDefault();
    }
    checkGiftThresholds(cartTotal_withoutGift, cartItems) {
        var curThreshold = 0;
        cartGiftData_sorted.forEach(item => {
            if (item.threshold <= cartTotal_withoutGift) {
                curThreshold++;
            }
        });

        let removeGift = [false, false, false];
        let addGift = [false, false, false];
        let cartGiftDataSortedIndexes = [null, null, null];
        let giftLineItemIDs = [null, null, null];

        let giftCounter = 1;
        for(let i = 0; i < cartGiftData_sorted.length; i++) {
            if (cartGiftData_sorted[i].type == "gift") {
                cartGiftDataSortedIndexes[giftCounter - 1] = i;

                let itemExists = false;
                cartItems.forEach(item => {
                    if (item.variantID == cartGiftData_sorted[i].variantID && Object.values(item.properties).includes(giftCounter + ". GWP Gift")) {
                        itemExists = true;
                        giftLineItemIDs[giftCounter - 1] = item.id;
                    }
                });

                if (i < curThreshold && !itemExists) {
                    addGift[giftCounter - 1] = true;
                } else if (i >= curThreshold && itemExists) {
                    removeGift[giftCounter - 1] = true;
                }

                giftCounter++;
            }
        }

        return {
            "curThreshold": curThreshold,
            "removeGift": removeGift,
            "addGift": addGift,
            "cartGiftDataSortedIndexes": cartGiftDataSortedIndexes,
            "giftLineItemIDs": giftLineItemIDs
        }
    }
    updateGiftsInCart(actionType, giftNumber, cartGiftDataSortedIndex, giftLineItemID) {
        if (actionType == "add") {
            var formData = {};

            // Check if two gifts should be added at the same time
            if (Array.isArray(giftNumber)) {
                formData = {
                    "sections": "cart-drawer,variant-added",
                    "items": []
                };
                for (let i = 0; i < giftNumber.length; i++) {
                    formData["items"].push(
                        {
                            "id": cartGiftData_sorted[cartGiftDataSortedIndex[i]].variantID,
                            "quantity": 1,
                            "properties": {
                                "_gwp_info": giftNumber[i] + ". GWP Gift"
                            }
                        }
                    );
                }
            } else {
                formData = {
                    "items": [{
                        "id": cartGiftData_sorted[cartGiftDataSortedIndex].variantID,
                        "quantity": 1,
                        "properties": {
                            "_gwp_info": giftNumber + ". GWP Gift"
                        }
                    }],
                    "sections": "cart-drawer,variant-added"
                };
            }
            return fetch(Shopify.routes.root + 'cart/add.js', {
                body: JSON.stringify(formData),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                }
            });
        } else if (actionType == "remove") {

            // Set quantity of gift to 0
            return fetch(Shopify.routes.root + 'cart/change.js', {
                body: JSON.stringify({ id: giftLineItemID, quantity: 0 }),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                }
            });
        }
    }
    async removeMultipleGiftsFromCart(giftNumber, giftLineItemID) {
        let response;
        for (let i = 0; i < giftNumber.length; i++) {
            response = await fetch(window.theme.localeRootUrl + '/cart/change.js', {
                body: JSON.stringify({
                    id: giftLineItemID[i],
                    quantity: 0,
                    sections: "cart-drawer,variant-added"
                }),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                }
            });
        }
        return response;
    }
    show(event = null) {
        if (event != null) {
            event.preventDefault();
        }
        if (this.open) {
            return;
        }
        const pageOverlay = document.querySelector(".PageOverlay");
        pageOverlay.removeEventListener("click", this._onCloseButtonClicked);
        pageOverlay.addEventListener("click", this._onCloseButtonClicked);
        const html = document.querySelector("html");
        html.classList.add("no-scroll");
        pageOverlay.classList.add("overlay-is-visible", "overlay--cart");
        this.setAttribute("aria-hidden", "false");
    }
    hide() {
        if (!this.open) {
            return;
        }
        const pageOverlay = document.querySelector(".PageOverlay")
        pageOverlay.classList.remove("overlay-is-visible", "overlay--cart");
        pageOverlay.removeEventListener("click", this._onCloseButtonClicked);
        const html = document.querySelector("html");
        html.classList.remove("no-scroll");
        this.setAttribute("aria-hidden", "true");
    }
    setShippingCosts(wrapper = this) {
        const shippingSelect = wrapper.querySelector("#cartShippingSelection");
        if (shippingSelect) {
            const zone = shippingSelect.value;
            const zoneElement = wrapper.querySelector(`[name='${zone}']`);
            const cartTotal = wrapper.querySelector("#cartTotal");
            const cartShipping = wrapper.querySelector("#cartShippingCosts");

            const helperElement = wrapper.querySelector(`.shippingSelect--helperElement`);
            helperElement.innerHTML = zone;
            shippingSelect.value = zone;
            shippingSelect.style.width = `${helperElement.offsetWidth + 31}px`;
            if (zoneElement.dataset.calcLater == "false") {
                cartTotal.innerHTML = `<strong>${zoneElement.dataset.curCartTotal}</strong>`;
                cartShipping.innerHTML = zoneElement.dataset.curShippingCosts;
            } else {
                cartTotal.innerHTML = zoneElement.dataset.message;
                cartShipping.innerHTML = zoneElement.dataset.message;
            }
        }
    }
    async _onCartChanged(event) {
        let updatedDrawerContent = new DOMParser().parseFromString(event.detail.cart["sections"]["cart-drawer"], "text/html");
        let cart = event.detail.cart;
        if (!event.detail.lineItemIsGift) {
            // Content for GWP - START

            this.cartTotal = cart.total_price;
            let cartTotal_withoutGift = 0;

            const cartItems = [];
            for (let i = 0; i < cart.items.length; i++) {
                const item = cart.items[i];
                let ignoreProduct = false;
                const domElement = updatedDrawerContent.querySelector(`[data-line-id='${item.key}']`);
                const tagArray = domElement.dataset.productTags.split(",");
                tagArray.forEach(tag => {
                    if (tag == gwpExclutionTag) {
                        ignoreProduct = true;
                    }
                });
                if (item.properties != null && Object.keys(item.properties).includes("GWP")) {
                    ignoreProduct = true;
                }
                if (!ignoreProduct) {
                    cartTotal_withoutGift += parseFloat(item.line_price);
                }

                cartItems.push({
                    "variantID": item.variant_id,
                    "productID": item.product_id,
                    "properties": item.properties,
                    "id": item.key,
                    "quantity": parseInt(item.quantity),
                    "price": parseInt(item.price)
                });
            }

            this.cartItems = cartItems;
            this.cartTotal_withoutGift = cartTotal_withoutGift;

            let giftStatus = this.checkGiftThresholds(this.cartTotal_withoutGift, this.cartItems);

            let promise = null;
            let response = null;
            let cartChanged = false;

            if (giftStatus.addGift[0] || giftStatus.addGift[1] || giftStatus.addGift[2]) {
                let param0 = [];
                let param1 = [];
                let param2 = [];
                for (let i = 0; i < giftStatus.addGift.length; i++) {
                    if (giftStatus.addGift[i]) {
                        param0.push(i + 1);
                        param1.push(giftStatus.cartGiftDataSortedIndexes[i]);
                        param2.push(giftStatus.giftLineItemIDs[i]);
                    }
                }
                if (param0.length == 1) {
                    promise = this.updateGiftsInCart("add", param0[0], param1[0], param2[0]);
                    cartChanged = true;
                } else {
                    promise = this.updateGiftsInCart("add", param0, param1, param2);
                    cartChanged = true;
                }
            } else if (giftStatus.removeGift[0] || giftStatus.removeGift[1] || giftStatus.removeGift[2]) {
                let param0 = [];
                let param1 = [];
                let param2 = [];
                for (let i = 0; i < giftStatus.removeGift.length; i++) {
                    if (giftStatus.removeGift[i]) {
                        param0.push(i + 1);
                        param1.push(giftStatus.cartGiftDataSortedIndexes[i]);
                        param2.push(giftStatus.giftLineItemIDs[i]);
                    }
                }
                response = await this.removeMultipleGiftsFromCart(param0, param2);
                cartChanged = true;
            } else {
                promise = new Promise(function (resolve, reject) {
                    resolve(true);
                });
            }

            if (promise != null) {
                response = await promise;
            }

            if (cartChanged) {
                const responseJson = await response.json();
                updatedDrawerContent = new DOMParser().parseFromString(responseJson["sections"]["cart-drawer"], "text/html");
            }
            // Content for GWP - END
        }
        updatedDrawerContent.querySelector('button[data-action="close-drawer"]').addEventListener("click", this._onCloseButtonClicked);
        this.setShippingCosts(updatedDrawerContent.querySelector("cart-drawer"));
        if (updatedDrawerContent.querySelector("#cartShippingSelection") && document.querySelector(`.shippingSelect--helperElement`)) {
            updatedDrawerContent.querySelector("#cartShippingSelection").style.width = `${document.querySelector(`.shippingSelect--helperElement`).offsetWidth + 31}px`;
        }
        if (updatedDrawerContent.querySelectorAll("line-item").length > 0) {
            document.querySelector(".Header__CartDot").classList.add("is-visible");
            const currentLineItemsElement = this.querySelector(".Cart__ItemList");
            const updatedLineItemsElement = updatedDrawerContent.querySelector(".Cart__ItemList");
            if (!currentLineItemsElement) {
                this.replaceChildren(document.createRange().createContextualFragment(updatedDrawerContent.querySelector(".cart-drawer").innerHTML));
                this.reconnectedCallback();
            } else {
                currentLineItemsElement.innerHTML = updatedLineItemsElement.innerHTML;
                this.querySelector('.Drawer__Footer').replaceChildren(...updatedDrawerContent.querySelector('.Drawer__Footer').childNodes);
                this.querySelector('.Drawer__ProgressBar').replaceChildren(...updatedDrawerContent.querySelector('.Drawer__ProgressBar').childNodes);
                this.querySelector('.Drawer__CartGiftSection').replaceChildren(...updatedDrawerContent.querySelector('.Drawer__CartGiftSection').childNodes);
            }
            this.querySelector('.Drawer__Footer .Cart__Checkout').addEventListener("click", this._onCheckoutButtonClicked);
        } else {
            document.querySelector(".Header__CartDot").classList.remove("is-visible");
            // await animate4(this.children, { opacity: 0 }, { duration: 0.15 }).finished;
            this.replaceChildren(...updatedDrawerContent.querySelector(".cart-drawer").childNodes);
            this.reconnectedCallback();
            // animate4(this.querySelector(".empty-state"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.15 });
        }
        this.querySelector(".Drawer__Main").scrollTo(0, 0);
    }
    async _onVariantAdded(event) {
        this.show();
    }
    async _onCartRefresh() {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = await (await fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)).text();
        this.replaceChildren(...tempDiv.querySelector("#cart-drawer").children);
        this.querySelector('.Drawer__Footer .Cart__Checkout').addEventListener("click", this._onCheckoutButtonClicked);
    }
    _onCheckoutButtonClicked() {
        let button = document.querySelector('.Cart__Checkout');        
        //button.querySelector('.Button__Text').style.opacity = "0";        
        button.setAttribute("aria-busy", "true");      
        setTimeout(function(){ 
          // Set short timeout in order to let the button submit and then disable it
          button.setAttribute("disabled", "disabled");
        }, 10);
    }
};

if (!window.customElements.get("cart-drawer")) {
    window.customElements.define("cart-drawer", CartDrawer);
}

// js/common/cart/line-item-quantity.js
const LineItemActions = class extends HTMLElement {
    constructor() {
        super();
        this._onQuantityChangedListener = this._onQuantityChanged.bind(this);
        this._onRemoveLinkClickedListener = this._onRemoveLinkClicked.bind(this);
        this._onQuantityChangeButtonListener = this._onQuantityChangeButtonClicked.bind(this);
        this._onLineItemQuantityChangeListener = this._onLineItemQuantityChanged.bind(this);

    }
    connectedCallback() {
        this.addEventListener("change", this._onQuantityChangedListener);
        // Removed because of b2b Store
        this.querySelector(".CartItem__Remove").addEventListener("click", this._onRemoveLinkClickedListener);
        this.querySelectorAll("[data-action=\"update-item-quantity\"]").forEach((item) => {
            item.addEventListener("click", this._onQuantityChangeButtonListener);
        });
        // document.addEventListener("line-item:change", this._onLineItemQuantityChangeListener);
    }
    get lineKey() {
        return this.getAttribute("data-line-key");
    }
    disconnectedCallback() {
        this.removeEventListener("change", this._onQuantityChangedListener);
        // Removed because of b2b Store
        this.querySelector(".CartItem__Remove").removeEventListener("click", this._onRemoveLinkClickedListener);
        this.querySelectorAll("[data-action=\"update-item-quantity\"]").forEach((item) => {
            item.removeEventListener("click", this._onQuantityChangeButtonListener);
        });
        // document.removeEventListener("line-item:change", this._onLineItemQuantityChangeListener);
    }
    _onQuantityChangeButtonClicked(event) {
        event.preventDefault();
        
        const oldQuantity = this.querySelector("input").value;
        const newQuantity = event.target.getAttribute("data-quantity");
        this.querySelector("input").value = newQuantity;
        this._changeLineItemQuantity(newQuantity, oldQuantity);
    }
    _onQuantityChanged(event) {
        this._changeLineItemQuantity(parseInt(event.target.value));
    }
    _onLineItemQuantityChanged(event) {
        this.querySelector("input").value = event.detail.quantity;
        this.querySelectorAll("[data-action=\"update-item-quantity\"]").forEach((item) => {
            const step = parseInt(item.getAttribute("step"));
            item.setAttribute("data-quantity", event.detail.quantity + step);
        });
    }
    _onRemoveLinkClicked(event) {
        if (event.target.tagName !== "A" || !event.target.href.includes("/cart/change")) {
            return;
        }
        event.preventDefault();
        const url = new URL(event.target.href);
        this._changeLineItemQuantity(parseInt(url.searchParams.get("quantity")));
    }
    async _changeLineItemQuantity(targetQuantity, oldQuantity = null) {
        const lineItem = this.closest("line-item");
        lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));

        const changeResponse = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: this.lineKey,
                quantity: targetQuantity,
                oldQuantity: oldQuantity,
                sections: ["cart-drawer","cart-template"]
            })
        });
        const cartContent = await changeResponse.json();
        if (changeResponse.ok) {
            let changedItemInfo = null;
            if (targetQuantity > 0) {
                changedItemInfo = cartContent["items"].find((lineItem2) => lineItem2["key"] === this.lineKey);
            }
            const lineItemAfterChange = cartContent["items"].filter((lineItem2) => lineItem2["key"] === this.lineKey);
            lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
                bubbles: true,
                detail: {
                    quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"],
                    cart: cartContent,
                    lineItemIsGift: lineItem.dataset.properties.includes("GWP Gift")
                }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    baseEvent: "line-item:change",
                    cart: cartContent,
                    lineItemIsGift: lineItem.dataset.properties.includes("GWP Gift"),
                    newItem: changedItemInfo,
                }
            }));
        } else {
            document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
                bubbles: true,
                detail: {
                    error: changeResponse["message"]
                }
            }));
            lineItem?.dispatchEvent(new CustomEvent("line-item:change-interrupted", {
                bubbles: true,
                detail: {}
            }));
        }
    }
};
if (!window.customElements.get("line-item-actions")) {
    window.customElements.define("line-item-actions", LineItemActions);
}

const LineItem = class extends HTMLElement {
    connectedCallback() {
        this.addEventListener("line-item:change-interrupted", this._onLineItemChangeInterrupted.bind(this));
        this.addEventListener("line-item:change", this._onChanged.bind(this));
        this.addEventListener("line-item:will-change", this._onWillChange.bind(this));
    }
    disconnectedCallback() {
        this.removeEventListener("line-item:change-interrupted", this._onLineItemChangeInterrupted.bind(this));
        this.removeEventListener("line-item:change", this._onChanged.bind(this));
        this.removeEventListener("line-item:will-change", this._onWillChange.bind(this));
    }
    _onLineItemChangeInterrupted() {
        this.removeAttribute("aria-busy");
        this.querySelector("input").disabled = false;
        this.querySelector("input").value = this.dataset.quantity;
    }
    _onWillChange() {
        this.setAttribute("aria-busy", "true");
        this.querySelector("input").disabled = true;
        this.querySelectorAll(".CartItem__Actions a").forEach((e) => e.disabled = true);
    }
    async _onChanged(event) {
        this.removeAttribute("aria-busy");
        this.querySelector("input").disabled = false;
        this.querySelectorAll("button").forEach((e) => e.disabled = false);
        if (event.detail.cart["item_count"] === 0 || event.detail.quantity !== 0) {
            return;
        }
        // let marginCompensation = 0;
        // if (this.nextElementSibling) {
        //     marginCompensation = `-${getComputedStyle(this.nextElementSibling).paddingTop}`;
        // }
        // await animate4(this, { height: [`${this.clientHeight}px`, 0], marginBottom: [0, marginCompensation], overflow: "hidden", opacity: [1, 0] }, { duration: 0.2, easing: "ease" }).finished;
        this.remove();
    }
};
if (!window.customElements.get("line-item")) {
    window.customElements.define("line-item", LineItem);
}

const CartProductRecommendations = class extends HTMLElement {
    constructor() {
        super();

        this._updateShopifyRecommendations = this.updateShopifyRecommendations.bind(this);

        if (this.dataset.shopifyRecom == "true") {
            this.updateShopifyRecommendations();
        }
    }

    connectedCallback() {
        document.addEventListener("cart:change", this._updateShopifyRecommendations);
        document.addEventListener("cart:refresh", this._updateShopifyRecommendations);
    }

    disconnectedCallback() {
        document.removeEventListener("cart:change", this._updateShopifyRecommendations);
        document.removeEventListener("cart:refresh", this._updateShopifyRecommendations);
    }

    async updateShopifyRecommendations(event = null) {
        let productId = null;

        if (event == null) {
            productId = this.dataset.productId;
        } else if (event.detail.newItem != null) {
            productId = event.detail.newItem.product_id;
        } else if (event.detail.cart != null && event.detail.cart.items.length > 0) {
            productId = event.detail.cart.items[0].product_id;
        } else {
            productId = this.dataset.productId;
        }

        if (productId != null && productId != "") {
            const url = `${this.dataset.url}?section_id=${this.dataset.sectionId}&product_id=${productId}&limit=${this.dataset.limit}&intent=${this.dataset.intent}`;
            const response = await fetch(url);
            const text = await response.text();

            const pattern = RegExp('Start Recommendation Wrapper[\\s\\S]*End Recommendation Wrapper', "g");
            const recommendationHtmlText = pattern.exec(text);

            if (recommendationHtmlText != null) {
                const recommendations = recommendationHtmlText[0].replace('Start Recommendation Wrapper -->', '').replace('<!-- End Recommendation Wrapper', '');
                this.innerHTML = recommendations;
            }
        }
    }
};

if (!window.customElements.get("cart-product-recommendations")) {
    window.customElements.define("cart-product-recommendations", CartProductRecommendations);
}

const CartGiftSection = class extends HTMLElement {
}

if (!window.customElements.get("cart-gift-section")) {
    window.customElements.define("cart-gift-section", CartGiftSection);
}

const HmFacetFilters = class extends HTMLElement {
    constructor() {
        super();

        this._onFilterChangedListener = this._onFilterChanged.bind(this);
        this._onFilterClearedListener = this._onFilterCleared.bind(this);
        this._onFiltersClearedListener = this._onFiltersCleared.bind(this);
        this._onMobileCloseListener = this._onMobileClose.bind(this);
        this._onInitFormListener = null;
        this._onInitResetButtons = this._initResetButtons.bind(this);

        this.closeButtons = this.querySelectorAll("[data-filter-close='close']");
        this.priceRangeMin = this.querySelector(".price-range__min") && this.querySelector(".price-range__min").min;
        this.priceRangeMax = this.querySelector(".price-range__max") && this.querySelector(".price-range__max").max;

        this._urlToRemove = this.dataset.urlToRemove;
    }

    connectedCallback() {
        this.querySelectorAll("[name^='filter.']").forEach((element) => {
            element.addEventListener("change", this._onFilterChangedListener);
        });

        this.querySelectorAll("[data-action='clear-filter']").forEach((element) => {
            element.addEventListener("click", this._onFilterClearedListener);
        });

        document.querySelectorAll("[data-action='clear-filters']").forEach((element) => {
            element.addEventListener("click", this._onFiltersClearedListener);
        });

        this.querySelectorAll(".hm-product-facet__button").forEach((element) => {
            element.addEventListener("click", this._onFilterChangedListener);
        });

        this.addEventListener("hm-facet-filters:init-form", this._onInitFormListener);
        document.addEventListener("hm-facet-filters:rerendered", this._onInitResetButtons);
    }

    disconnectedCallback() {
        this.querySelectorAll("[name^='filter.']").forEach((element) => {
            element.removeEventListener("change", this._onFilterChangedListener);
        });

        this.querySelectorAll("[data-action='clear-filter']").forEach((element) => {
            element.removeEventListener("click", this._onFilterClearedListener);
        });

        document.querySelectorAll("[data-action='clear-filters']").forEach((element) => {
            element.removeEventListener("click", this._onFiltersClearedListener);
        });

        this.querySelectorAll(".hm-product-facet__button").forEach((element) => {
            element.removeEventListener("click", this._onFilterChangedListener);
        });

        this.removeEventListener("hm-facet-filters:init-form", this._onInitFormListener);
        document.removeEventListener("hm-facet-filters:rerendered", this._onInitResetButtons);
    }

    _initResetButtons() {
        document.querySelectorAll("[data-action='clear-filters']").forEach((element) => {
            element.removeEventListener("click", this._onFiltersClearedListener);
        });
        document.querySelectorAll("[data-action='clear-filters']").forEach((element) => {
            element.addEventListener("click", this._onFiltersClearedListener);
        });
    }

    _onFiltersCleared(event) {
        event.preventDefault();
        triggerEvent(this, "facet:criteria-changed", { url: this._urlToRemove });
    }
    _onMobileClose() {-
        this.form.querySelectorAll('input[type="checkbox"], input[type="range"]').forEach((element) => {
            if (element.type === 'checkbox') {
                if (element.checked != this.initialFormState[element.id] && element.name == "filter.v.m.filter.farbe") element.parentElement.querySelector(".color-swatch__icon").classList.toggle("visually-hidden");
                element.checked = this.initialFormState[element.id];
            } else {
                element.value = this.initialFormState[element.id];
                element.dispatchEvent(new Event('input', { value: this.initialFormState[element.id] }))
            }
        });
        this.form.querySelectorAll('.filter-size__item').forEach((element) => {
            element.classList.remove('active');
            if (this.initialFormState[element.id]) element.classList.add('active');
            else element.classList.remove('active');
        });

        var productCountElements = document.querySelectorAll(`.hm-filter__product-count`);
        productCountElements.forEach((element) => element.innerHTML = this.initialProductCount);
    }
    _onFilterCleared(event, target) {
        event.preventDefault();
        let searchParams = this._getSearchParams();
        if (target.dataset.filter == "filter.v.m.filter.apple_watch") {
            searchParams.delete("filter.v.m.filter.apple_watch");
            searchParams.delete("filter.v.m.filter.umfang_min");
            searchParams.delete("filter.v.m.filter.umfang_max");
        } else {
            searchParams.delete(target.dataset.filter);
        }
        const searchParamsAsString = searchParams.toString();
        triggerEvent(this, "facet:criteria-changed", { url: `${window.location.pathname}?${searchParamsAsString}` });
    }
    _onFilterChanged(event, target) {
        const searchParamsAsString = this._getSearchParams().toString();
        const url = `${window.location.pathname}?${searchParamsAsString}`;

        var windowWidth = window.innerWidth;

        triggerEvent(this, "facet:criteria-changed", { url: url });
    }
    _triggerFilterChanged(url) {
        var windowWidth = window.innerWidth;

        triggerEvent(this, "facet:criteria-changed", { url: url });
    }
    _getSearchParams() {
        const formData = new FormData(this.querySelector("#facet-filters-form"));
        let searchParams = new URLSearchParams(formData);

        var paramUmfangMin = searchParams.get("filter.v.m.filter.umfang_min");
        var paramUmfangMax = searchParams.get("filter.v.m.filter.umfang_max");

        searchParams.delete("filter.v.m.filter.umfang_min");

        var paramPriceMin = searchParams.get("filter.v.price.gte");
        var paramPriceMax = searchParams.get("filter.v.price.lte");
        if (paramPriceMin == this.priceRangeMin && paramPriceMax == this.priceRangeMax) {
            searchParams.delete("filter.v.price.gte");
            searchParams.delete("filter.v.price.lte");
        }

        return searchParams;
    }
    _onSizeFilterClicked(event, target) {
        const size = target.dataset.size;
        const active = target.classList.contains("active");

        this.querySelector("#size-filter-small").classList.remove("active");
        this.querySelector("#size-filter-medium").classList.remove("active");
        this.querySelector("#size-filter-ultra").classList.remove("active");

        var searchParams = this._getSearchParams();

        if (!active) {
            target.classList.add("active");
            searchParams = this._setSizeSearchParams(searchParams, size);
        }

        const searchParamsAsString = searchParams.toString();
        const url = `${window.location.pathname}?${searchParamsAsString}`;
        this._triggerFilterChanged(url);
    }
    _setSizeFilterActive() {
        const searchParams = this._getSearchParams();
        const sizeSearchParams = searchParams.getAll("filter.v.m.filter.apple_watch");
        if (sizeSearchParams.includes("38") && sizeSearchParams.includes("40") && sizeSearchParams.includes("41")) {
            this.querySelector("#size-filter-small").classList.add("active");
        }
        if (sizeSearchParams.includes("42") && sizeSearchParams.includes("44") && sizeSearchParams.includes("45")) {
            this.querySelector("#size-filter-medium").classList.add("active");
        }
        if (sizeSearchParams.includes("49")) {
            this.querySelector("#size-filter-ultra").classList.add("active");
        }
    }
    _setSizeSearchParams(searchParams, size) {
        searchParams.delete("filter.v.m.filter.apple_watch");
        switch (size) {
            case "small":
                searchParams.append("filter.v.m.filter.apple_watch", 38);
                searchParams.append("filter.v.m.filter.apple_watch", 40);
                searchParams.append("filter.v.m.filter.apple_watch", 41);
                break;
            case "medium":
                searchParams.append("filter.v.m.filter.apple_watch", 42);
                searchParams.append("filter.v.m.filter.apple_watch", 44);
                searchParams.append("filter.v.m.filter.apple_watch", 45);
                break;
            case "ultra":
                searchParams.append("filter.v.m.filter.apple_watch", 49);
                break;
        }
        return searchParams;
    }
}

if (!window.customElements.get("hm-facet-filters")) {
    window.customElements.define("hm-facet-filters", HmFacetFilters);
}

const OpenableElement = class extends CustomHTMLElement {
    static get observedAttributes() {
        return ["open"];
    }
    constructor() {
        super();
    }
    connectedCallback() {
        this.delegate.on("click", ".openable__overlay", () => this.open = false);
        this.delegate.on("click", '[data-action="close"]', (event) => {
            event.stopPropagation();
            this.open = false;
        });
    }
    get requiresLoading() {
        return this.hasAttribute("href");
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(value) {
        if (value) {
            (async () => {
                await this._load();
                this.clientWidth;
                this.setAttribute("open", "");

            })();
            document.querySelector("html").classList.add("no-scroll-mobile");
        } else {
            this.removeAttribute("open");
            document.querySelector("html").classList.remove("no-scroll-mobile");
        }
    }
    /*get returnFocusOnDeactivate() {
        return !this.hasAttribute("return-focus") || this.getAttribute("return-focus") === "true";
    }*/
    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "open":
                if (oldValue === null && newValue === "") {
                    triggerEvent(this, "openable-element:open");
                } else if (newValue === null) {
                    triggerEvent(this, "openable-element:close");
                }
        }
    }
    async _load() {
        if (!this.requiresLoading) {
            return;
        }
        triggerNonBubblingEvent(this, "openable-element:load:start");
        const response = await fetch(this.getAttribute("href"));
        const element = document.createElement("div");
        element.innerHTML = await response.text();
        this.innerHTML = element.querySelector(this.tagName.toLowerCase()).innerHTML;
        this.removeAttribute("href");
        triggerNonBubblingEvent(this, "openable-element:load:end");
    }
};
if (!window.customElements.get("openable-element")) {
    window.customElements.define("openable-element", OpenableElement);
}

const HmPopoverContent = class extends OpenableElement {
    constructor () {
        super();
        this.sectionId = this.getAttribute("section-id");
        this.parentFacetFilters = document.querySelector(`[section-id="${this.sectionId}"].product-facet__filters`);
        this._handleClickListener = this._handleClick.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();
        this.delegate.on("click", ".popover__overlay", () => this.open = false);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }
    
    _handleClick(event) {
        if (this.open) {
            if (!this.contains(event.target)) {
                this.open = false;
            }
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        switch (name) {
            case "open":
                if (oldValue === null && newValue === "") {
                    setTimeout(() => {
                        document.addEventListener("click", this._handleClickListener)
                    }, 150);
                    if (this.parentFacetFilters) {
                        let rectParent = this.parentFacetFilters.getBoundingClientRect();
                        let rect = this.getBoundingClientRect();
                        if (rectParent.left > rect.left) {
                            this.style.left = `calc(50% + ${rectParent.left - rect.left}px)`;
                        } else if (rectParent.right < rect.right) {
                            this.style.left = `calc(50% - ${rect.right - rectParent.right}px)`;
                        }
                    }
                    document.documentElement.classList.toggle("lock-mobile", this.open);
                   
                } else if (newValue === null) {
                    setTimeout(() => {
                        document.removeEventListener("click", this._handleClickListener)
                    }, 150);
                }
        }
    }
}

if (!window.customElements.get("hm-popover-content")) {
    window.customElements.define("hm-popover-content", HmPopoverContent);
}

var HmToggleButton = class extends HTMLElement {
    static get observedAttributes() {
        return ["aria-expanded", "aria-busy"];
    }
    constructor() {
        super();
        if (this.hasAttribute("loader")) {
            this._prepareButton();
        }
        this.addEventListener("click", this._onButtonClick.bind(this));
        this.rootDelegate = new main_default(document.documentElement);
    }
    _onButtonClick() {
        this.isExpanded = !this.isExpanded;
    }
    connectedCallback() {
        document.addEventListener("openable-element:close", (event) => {
            if (this.controlledElement === event.target) {
                this.isExpanded = false;
                event.stopPropagation();
            }
        });
        document.addEventListener("openable-element:open", (event) => {
            if (this.controlledElement === event.target) {
                this.isExpanded = true;
                event.stopPropagation();
            }
        });
        this.rootDelegate.on("openable-element:load:start", `#${this.getAttribute("aria-controls")}`, () => {
            if (this.classList.contains("button")) {
                this.setAttribute("aria-busy", "true");
            } else if (this.offsetParent !== null) {
                triggerEvent(document.documentElement, "theme:loading:start");
            }
        }, true);
        this.rootDelegate.on("openable-element:load:end", `#${this.getAttribute("aria-controls")}`, () => {
            if (this.classList.contains("button")) {
                this.removeAttribute("aria-busy");
            } else if (this.offsetParent !== null) {
                triggerEvent(document.documentElement, "theme:loading:end");
            }
        }, true);
    }
    disconnectedCallback() {
        this.rootDelegate.destroy();
    }
    get isExpanded() {
        return this.getAttribute("aria-expanded") === "true";
    }
    set isExpanded(value) {
        this.setAttribute("aria-expanded", value ? "true" : "false");
    }
    get controlledElement() {
        return document.getElementById(this.getAttribute("aria-controls"));
    }
    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "aria-expanded":
                if (oldValue === "false" && newValue === "true") {
                    const test = document.getElementById(this.getAttribute("aria-controls"));
                    this.controlledElement.open = true;
                } else if (oldValue === "true" && newValue === "false") {
                    this.controlledElement.open = false;
                }
                break;
            case "aria-busy":
                if (this.hasAttribute("loader")) {
                    if (newValue === "true") {
                        this._startTransition();
                    } else {
                        this._endTransition();
                    }
                }
                break;
        }
    }
};
// Object.assign(ToggleButton.prototype, LoaderButtonMixin);
window.customElements.define("hm-toggle-button", HmToggleButton);
// if (!window.customElements.get("hm-toggle-button")) {
// }

var HmFilterRange = class extends HTMLElement {
    connectedCallback() {
        this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
        this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
        this.textInputLowerBound = this.querySelector(".price-range__input:first-child .rangeValue");
        this.textInputHigherBound = this.querySelector(".price-range__input:last-child .rangeValue");

        this.rangeStep = this.rangeLowerBound.step ? parseFloat(this.rangeLowerBound.step) : 1;
        this.maxRange = this.rangeLowerBound.dataset.maxRange;
        this.rangeLowerBoundMin = this.rangeLowerBound.min;

        if(this.rangeLowerBound.dataset.filterType == 'umfang') this._getUrlParamValues();
        this.textInputLowerBound.innerHTML = this.rangeLowerBound.value;
        this.textInputHigherBound.innerHTML = this.rangeHigherBound.value;
        this.dispatchEvent(new CustomEvent("hm-facet-filters:init-form", { bubbles: true }));

        this.rangeLowerBound.addEventListener("input", (event) => {
            triggerEvent(this, "facet:abort-loading");
            event.target.value = Math.min(parseFloat(event.target.value), parseFloat(this.textInputHigherBound.innerHTML || event.target.max) - this.rangeStep);
            event.target.parentElement.style.setProperty("--range-min", `${(parseFloat(event.target.value) - parseFloat(this.rangeLowerBoundMin)) / parseFloat(this.maxRange) * 100}%`);
            this.textInputLowerBound.innerHTML = event.target.value;
        });
        this.rangeHigherBound.addEventListener("input", (event) => {
            triggerEvent(this, "facet:abort-loading");
            event.target.value = Math.max(parseFloat(event.target.value), parseFloat(this.textInputLowerBound.innerHTML || event.target.min) + this.rangeStep);
            event.target.parentElement.style.setProperty("--range-max", `${(parseFloat(event.target.value) - parseFloat(this.rangeLowerBoundMin)) / parseFloat(this.maxRange) * 100}%`);
            this.textInputHigherBound.innerHTML = event.target.value;
        });
    }
    _getUrlParamValues() {
        var currentURL = window.location.href;

        var url = new URL(currentURL);
        var paramMinValues = url.searchParams.getAll('filter.v.m.filter.umfang_min').map(function(value) {
            return parseFloat(value);
        });
        var paramMaxValues = url.searchParams.getAll('filter.v.m.filter.umfang_max').map(function(value) {
            return parseFloat(value);
        });

        var paramMinValue = url.searchParams.get('umfang_min');
        var paramMaxValue = url.searchParams.get('umfang_max');


        this.rangeLowerBound.value = paramMinValue ? paramMinValue : this.rangeLowerBound.value;
        this.rangeHigherBound.value = paramMaxValue ? paramMaxValue : this.rangeHigherBound.value;
        this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseFloat(this.rangeLowerBound.value) - parseFloat(this.rangeLowerBoundMin)) / parseFloat(this.maxRange) * 100}%`);
        this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseFloat(this.rangeHigherBound.value) - parseFloat(this.rangeLowerBoundMin)) / parseFloat(this.maxRange) * 100}%`);
    }
};

if (!window.customElements.get("hm-filter-range")) {
    window.customElements.define("hm-filter-range", HmFilterRange);
}

var CollectionFacetWrapper = class extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener("facet:criteria-changed", this._rerender.bind(this));
    }

    disconnectedCallback() {
        this.removeEventListener("facet:criteria-changed", this._rerender.bind(this));
    }

    async _rerender(event) {
        history.replaceState({}, "", event.detail.url);

        const url = new URL(window.location);
        url.searchParams.set("section_id", this.getAttribute("section-id"));

        try {
          const response = await fetch(url.toString());
          const responseAsText = await response.text();
          const fakeDiv = document.createElement("div");
          fakeDiv.innerHTML = responseAsText;

          this.querySelector(".CollectionMain").innerHTML = fakeDiv.querySelector(".CollectionMain").innerHTML;

          this.querySelectorAll(".filter-count--wrapper").forEach((element) => {
            let filterId = element.getAttribute("for");
            element.innerHTML = fakeDiv.querySelector(`[for="${filterId}"].filter-count--wrapper`).innerHTML;
          });

            this.querySelectorAll("input[type='checkbox']").forEach((element) => {
                let filterId = element.getAttribute("id");
                let updatedCheckbox = fakeDiv.querySelector(`input[type='checkbox'][id='${filterId}']`);
                if (updatedCheckbox) {
                    element.checked = updatedCheckbox.checked;
                }
            });

            this.querySelectorAll("input[type='range']").forEach((element) => {
                let filterId = element.getAttribute("id");
                let updatedCheckbox = fakeDiv.querySelector(`input[type='range'][id='${filterId}']`);
                if (updatedCheckbox) {
                    element.value = updatedCheckbox.value;
                }
            });

            this.querySelectorAll(".price-range__input-group .rangeValue").forEach((element) => {
                let filterId = element.getAttribute("id");
                let updatedElement = fakeDiv.querySelector(`.price-range__input-group .rangeValue[id='${filterId}']`);
                if (updatedElement) {
                    element.innerHTML = updatedElement.innerHTML;
                }
            });

            // event.target.parentElement

            let priceRangeElement = this.querySelector(".price-range__range-group")
            let updatedPriceRangeElement = fakeDiv.querySelector(`.price-range__range-group`);
            if (updatedPriceRangeElement) {
                priceRangeElement.style.setProperty("--range-max", updatedPriceRangeElement.style.getPropertyValue("--range-max"));
                priceRangeElement.style.setProperty("--range-min", updatedPriceRangeElement.style.getPropertyValue("--range-min"));
            }

            triggerEvent(document, "hm-facet-filters:rerendered");
        } catch (e) {
          if (e.name === "AbortError") {
            return;
          }
        }
      }
};

if (!window.customElements.get("collection-facet-wrapper")) {
    window.customElements.define("collection-facet-wrapper", CollectionFacetWrapper);
}

const HeaderCartDot = class extends HTMLElement {
    constructor() {
        super();
        this._onCartChange = this._onCartChange.bind(this);
    }
    connectedCallback() {
        document.addEventListener("cart:change", this._onCartChange);
    }
    disconnectedCallback() {
        document.removeEventListener("cart:change", this._onCartChange);
    }
    _onCartChange(event) {
        this.classList.toggle("is-visible", event.detail.cart.item_count > 0);
    }
}
if (!window.customElements.get("header-cart-dot")) {
    window.customElements.define("header-cart-dot", HeaderCartDot);
}

var SwiperWrapper = class extends HTMLElement {
    constructor() {
        super();
        this.initHandler = this.init.bind(this);
        this.config = this.dataset.swiperConfig ? JSON.parse(this.dataset.swiperConfig) : {};
    }
    connectedCallback() {
        document.addEventListener("DOMContentLoaded", this.initHandler);
    }
    disconnectedCallback() {
        document.removeEventListener("DOMContentLoaded", this.initHandler);
    }   
    init() {
        if (this.config == {}) {
            return;
        }

        this.swiper = new Swiper(`#${this.id} .swiper`, this.config);
    }
}

if (!window.customElements.get("swiper-wrapper")) {
    window.customElements.define("swiper-wrapper", SwiperWrapper);
}


var MarketPopup = class extends OpenableElement {
    constructor () {
        super();
    }
    connectedCallback() {
        console.log("MarketPopup");
        super.connectedCallback();

        this.discardButton.addEventListener("click", this._discardSuggestion.bind(this));
        this.open = true;
        // this._initCountryPopup();
    }
    get discardButton() {
        return this.querySelector("[discard-button]");
    }
    get availableCountries() {
        const countries = this.querySelector("[available-countries]").innerHTML;
        return JSON.parse(countries);
    }
    get labels() {
        const labels = this.querySelector("[labels]").innerHTML;
        return JSON.parse(labels);
    }
    get shouldTrapFocus() {
        return false;
    }
    _discardSuggestion() {
        this._setCookie("locationValidated", "true", 7);
        this.open = false;
    }
    _localizeLabels(langCode) {
        const labels = this.labels[langCode];
        const heading = this.querySelector(".heading");
        const content = this.querySelector(".country-modal__content");
        const discardButton = this.querySelector("[discard-button]");

        if (heading) {
        heading.innerHTML = labels.heading;
        }
        if (content) {
        content.innerHTML = labels.text;
        }
        if (discardButton) {
        discardButton.innerHTML = labels.discard;
        }
    }
    _capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    _
    // _initCountryPopup() {
    //     const apiKey = "ekdpqd8nbdxu6os6";
    //     const url = "https://eu.api.ipregistry.co";
    //     const cookieName = "locationValidated";
    //     const queryString = window.location.search;
    //     const urlParams = new URLSearchParams(queryString);

    //     if (this._getCookie(cookieName) == "" || this._getCookie(cookieName) == "false") {
    //     if (urlParams.get("locationValid") != null && urlParams.get("locationValid") == "true") {
    //         this._setCookie(cookieName, "true", 7);
    //     } else {
    //         fetch(`${url}/?key=${apiKey}`)
    //         .then(response => response.json())
    //         .then(async (response) =>{
    //         // Detected User Country by API
    //         const detectedCountry = response.location.country.name.toLowerCase();
    //         // const detectedCountry = "netherlands";
    //         const detectedCountryISOCode = response.location.country.code;
    //         // const detectedCountryISOCode = "NL";
            
    //         // Detected User Language
    //         var userLangCode = "en";
    //         if (window.navigator.language.slice(0,2) == "de") {
    //             userLangCode = "de";
    //         }

    //         if (Shopify.country == detectedCountryISOCode) {
    //             // User is in the correct country shop
    //             this._setCookie(cookieName, "true", 7);
    //         } else {
    //             // Check if the user is in a country where we have a shop
    //             if (Object.keys(this.availableCountries).includes(detectedCountryISOCode)) {
    //             // User is in a country where we have a shop
    //             var translatedCountry = detectedCountry;
    //             if (userLangCode == "de") {
    //                 const response = await fetch(`https://restcountries.com/v3.1/alpha/${detectedCountryISOCode}`);
    //                 const json = await response.json();
    //                 if (json) {
    //                 translatedCountry = json[0].translations?.deu?.common;
    //                 }
    //             }
    //             // const button = this.querySelector('[type="submit"]');
    //             // button.value = detectedCountryISOCode;
    //             // button.innerHTML = `${this._capitalizeFirstLetter(translatedCountry)} Shop`;
    //             this._localizeLabels(userLangCode);
    //             this._updateLocaleInForm(detectedCountryISOCode, translatedCountry);
    //             this.open = true;
    //             } else {
    //             // User is in a country where we don't have a shop
    //             // Check if international shop is currently active
    //             if (window.location.origin.includes("paperandtea.com")) {
    //                 // International shop is active
    //                 this._setCookie(cookieName, "true", 7);
    //             } else {
    //                 // Redirect to international shop
    //                 this._updateLocaleInForm("US", "International");
    //                 this._localizeLabels(userLangCode);
    //                 this.open = true;
    //             }
    //             }
    //         }
    //         });
    //     }
    //     }
    // }
    _updateLocaleInForm(isoCode, countryName) {
        const button = this.querySelector('[type="submit"]');
        button.value = isoCode;
        button.innerHTML = `${this._capitalizeFirstLetter(countryName)} Shop`;
        const input = this.querySelector(`[name="country_code"]`);
        input.value = isoCode;
    }
    _setCookie(cookieName, cookieValue, expiringDays) {
        const d = new Date();
        d.setTime(d.getTime() + (expiringDays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/;SameSite=Strict";
    }
    _getCookie(cookieName) {
        let name = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
        }
        return "";
    }
    };
    window.customElements.define("market-popup", MarketPopup);